module.exports = __webpack_public_path__ + "media/svg-new/f-calendar-291a6936.svg";